<template>
  <div class="member-page">
    <div class="overflow-hidden">
      <div>
        <a-card class="member-content" :bordered="false">
          <div class="pb-4">
            <div class="search-container">
              <div class="search-box-wrapper">
                <div class="flex flex-wrap gap-4">
                  <div class="flex items-center">
                    <span class="pr-2 leading-8">申请编号:</span>
                    <a-textarea
                      style="width: 150px"
                      autoSize
                      v-model="queryParam.eq.apply_no"
                      @pressEnter="press_enter"
                    ></a-textarea>
                  </div>
                  <div class="flex items-center">
                    <span class="pr-2 leading-8">申请日期:</span>
                    <a-range-picker
                    style="width: 260px"
                      v-model="queryParam.time.create_time"
                      format="YYYY-MM-DD"
                      valueFormat="YYYY-MM-DD"
                    />
                  </div>
                  <div class="flex items-center">
                    <span class="pr-2 leading-8">申请人:</span>
                    <a-textarea
                      style="width: 150px"
                      autoSize
                      v-model="queryParam.custom.apply_user_keyword"
                      @pressEnter="press_enter"
                    ></a-textarea>
                  </div>
                  <div class="flex items-center">
                    <span class="pr-2 leading-8">状态:</span>
                    <a-select style="width: 100px" allowClear v-model="queryParam.eq.status">
                      <a-select-option :value="0">待审核</a-select-option>
                      <a-select-option :value="1">待结算</a-select-option>
                      <a-select-option :value="2">已结算</a-select-option>
                      <a-select-option :value="3">已驳回</a-select-option>
                    </a-select>
                  </div>
                </div>
              </div>
              <div class="search-actions">
                <a-button type="primary" @click="gets(1)"><a-icon type="search"></a-icon>搜索</a-button>
                <a-button type="default" @click="reset" icon="reload">重置</a-button>
              </div>
            </div>
          </div>
          <a-table
            :loading="loading"
            :columns="columns"
            :data-source="list"
            :pagination="pagination"
            bordered
            row-key="id"
            size="small"
          >
            <template slot="performance" slot-scope="text">
              {{ formatMoney(text) }}
            </template>
            <template slot="apply_user" slot-scope="text, record">
              {{ record.apply_user_nick_name || record.apply_user_name || '-' }}
            </template>
            <template slot="status" slot-scope="text">
              <span :class="statusClass(text)">{{ statusText(text) }}</span>
            </template>
          </a-table>
        </a-card>
      </div>
    </div>
  </div>
</template>

<script>
import { teamPerformances } from '@/api/business';

import { columns, statusClass, statusText } from './_index';

export default {
  data() {
    return {
      queryParam: { custom: {}, time: {}, like: {}, eq: {} },
      columns,
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '50'],
        showSizeChanger: true,
        onChange: (page, pageSize) => {
          this.pagination.current = page;
          this.pagination.pageSize = pageSize;
          this.gets();
        },
        onShowSizeChange: (current, size) => {
          this.pagination.current = current;
          this.pagination.pageSize = size;
          this.gets();
        },
        showTotal: (total) => `共 ${total} 条`,
      },
      loading: true,
      list: [],
    };
  },
  activated() {
    this.gets(1);
  },
  methods: {
    async gets(current) {
      this.loading = true;
      if (current) {
        this.pagination.current = current;
      }
      try {
        const res = await teamPerformances({
          current: this.pagination.current,
          pageSize: this.pagination.pageSize,
          qp: JSON.stringify(this.queryParam),
        });
        this.list = res.data || [];
        this.$set(this.pagination, 'total', res.total || 0);
      } finally {
        this.loading = false;
      }
    },
    press_enter(e) {
      e.preventDefault();
      this.gets(1);
    },
    reset() {
      this.queryParam = { custom: {}, time: {}, like: {}, eq: {} };
      this.gets(1);
    },
    formatMoney(val) {
      if (val === null || val === undefined || val === '') {
        return '-';
      }
      const num = Number(val);
      if (Number.isNaN(num)) {
        return '-';
      }
      return `￥${num.toFixed(2)}`;
    },
    statusText(status) {
      return statusText(status);
    },
    statusClass(status) {
      return statusClass(status);
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/style/search-toolbar.less';
</style>
